document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) window.cartDrawer = drawer;
});



if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    constructor() {
      super();
      this.bundleProductAtc = this.querySelectorAll('.bundle_product_atc');
      this.bundleProductRemove = this.querySelectorAll('.bundle_product_remove');
      this.bundleFinalAtc = this.querySelector('.bundle_final_atc');
      this.bundleActionBtnWrapper = this.querySelectorAll('.bundle_action_btn-wrapper');
      this.bundleSelectedProductsPrice = this.querySelector('.bundle_selected-products-price');
      this.popupTriggers = this.querySelectorAll('.bundle_popup-trigger');
      this.price = this.getAttribute('data-price');
      this.bundleProductsCount = this.querySelector('.bundle_products-count');
      this.selectedproducts = [];
      this.maxCount = parseInt(this.getAttribute('data-count'));
      this.selectedProductsPrice = 0;
    }
    connectedCallback() {
      this.bundleProductAtc.forEach((button) => {
        button.addEventListener('click', this.onAddToBox.bind(this));
      });
      this.bundleProductRemove.forEach((button) => {
        button.addEventListener('click', this.onRemoveFromBox.bind(this));
      });
      this.bundleFinalAtc.addEventListener('click', this.onBundleFinalAtc.bind(this));
      this.popupTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          this.openPopup(event);
        });
      })
    }
    onAddToBox(event){
      const wrapper = event.target.closest('.bundle_action_btn-wrapper');
      const variantId = event.target.getAttribute('data-variant-id');
      const variantPrice = event.target.getAttribute('data-variant-price');
      if (this.selectedproducts.length >= this.maxCount || this.selectedproducts.includes(variantId)) {
        return;
      }
      if(variantPrice){
        this.selectedProductsPrice += parseFloat(variantPrice);
      }
      this.appendPrice();
      this.selectedproducts.push(variantId);
      if (this.selectedproducts.length > 0) {
        this.bundleProductsCount.textContent = `(${this.selectedproducts.length})`;
      }else{
        this.bundleProductsCount.textContent = '';
      }
      if (this.selectedproducts.length === this.maxCount) {
        this.bundleFinalAtc.removeAttribute('disabled');
        this.bundleProductAtc.forEach((button) => {
          const currentVariantId = button.getAttribute('data-variant-id');
          if (!this.selectedproducts.includes(currentVariantId)) {
            button.setAttribute('disabled', true);
          }
        });
      }
      wrapper.classList.add('selected');
    }
    onRemoveFromBox(event) {
      const wrapper = event.target.closest('.bundle_action_btn-wrapper');
      const variantId = event.target.getAttribute('data-variant-id');
      const variantPrice = event.target.getAttribute('data-variant-price');
      if(variantPrice){
        this.selectedProductsPrice -= parseFloat(variantPrice);
      }
      this.appendPrice();
      this.selectedproducts = this.selectedproducts.filter(id => id !== variantId);
      if (this.selectedproducts.length > 0) {
        this.bundleProductsCount.textContent = `(${this.selectedproducts.length})`;
      }else{
        this.bundleProductsCount.textContent = '';
      }
      if (this.selectedproducts.length < this.maxCount) {
        this.bundleFinalAtc.setAttribute('disabled', true);
        this.bundleProductAtc.forEach((button) => {
          button.removeAttribute('disabled');
        });
      }
      wrapper.classList.remove('selected');
    }

    appendPrice(){
      if (this.selectedProductsPrice > 0 && this.selectedProductsPrice > parseInt(this.price)) {
        let price = this.selectedProductsPrice.toFixed(2) / 100;
        this.bundleSelectedProductsPrice.textContent = `Rs. ${price}`;
      }else{
        this.bundleSelectedProductsPrice.textContent = `Rs.xxxx`;
      }
    }

  


    async onBundleFinalAtc() {
      if (this.selectedproducts.length === 0) return;

      const bundleId = 'bundle_' + Date.now();

      this.bundleFinalAtc.setAttribute('disabled', true);
      this.bundleProductAtc.forEach(btn => btn.setAttribute('disabled', true));
      this.bundleActionBtnWrapper.forEach(wrapper => wrapper.classList.add('selected'));

      try {
        // Prepare formData with items array for bulk add
        const formData = {
          items: this.selectedproducts.map(id => ({
            id: Number(id),
            quantity: 1,
            properties: {
              'BundleProduct': 'Product is part of bundle',
              'BundleID': bundleId
            }
          }))
        };

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        }).then(res => res.json());

        // ✅ Properly refresh and open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        
        if (cartDrawer && typeof cartDrawer.refreshCart === 'function') {
          await cartDrawer.refreshCart();
          
          setTimeout(() => {
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open();
            }
          }, 100);
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }

      } catch (error) {
        console.error('Error adding bundle to cart:', error);
      } finally {
        // Reset UI
        this.bundleActionBtnWrapper.forEach(wrapper => wrapper.classList.remove('selected'));
        this.bundleFinalAtc.removeAttribute('disabled');
        this.bundleProductAtc.forEach(button => button.removeAttribute('disabled'));
        this.selectedproducts = [];
        this.bundleProductsCount.textContent = '';
        this.selectedProductsPrice = 0;
        this.bundleSelectedProductsPrice.textContent = `Rs.xxxx`;
      }
    }









      openPopup(event){
        let targetElement = event.target.closest('.bundle_popup-trigger');
        let variantId = targetElement.getAttribute('data-variant-id');
        let popup = this.querySelector(`#popup-${variantId}`);
        if (!popup) return;
        popup.classList.remove('hidden');
        popup.classList.add('background-overlay')
        popup.querySelector('.bundle-popup-close').addEventListener('click', () => {
          popup.classList.add('hidden');
          popup.classList.remove('background-overlay');
        });
      }
    };
    customElements.define('product-bundle', ProductBundle);
  }

if (!customElements.get('bundle-remove')) {
  class BundleRemove extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const svg = this.querySelector('.bundle-remove-svg');

      if (svg) {
        svg.addEventListener('click', this.onRemoveBundle.bind(this));
      }
    }

    async onRemoveBundle() {
      const variantIdsString = this.getAttribute('data-variant-ids');
      if (!variantIdsString) return;

      try {
        const variantIds = variantIdsString
          .split(',')
          .map(id => id.trim())
          .filter(id => id);

        const updates = {};
        variantIds.forEach(id => {
          updates[id] = 0;
        });

        const response = await fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        const data = await response.json();
        console.log('Removed bundle items:', data);

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        console.log(cart.items.length,'cart object')

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refreshCart === 'function') {
          await cartDrawer.refreshCart();
          if (cart.items.length == 0) {
            cartDrawer.classList.add('is-empty');
          }
        }
      } catch (error) {
        console.error('Error removing bundle:', error);
      } finally {
        mmajaxcart.AjaxcartRender();
        mmajaxcart.AjaxcartOpen();
      }
    }
  }

  customElements.define('bundle-remove', BundleRemove);
}